const idProvider = {
  id: 0,
  getNext(){
    idProvider.id++;
    return idProvider.id;
  }
}

export default idProvider;